import { render, staticRenderFns } from "./SymptomInvestigationTable.vue?vue&type=template&id=68ed35d6&scoped=true"
import script from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
export * from "./SymptomInvestigationTable.vue?vue&type=script&lang=js"
import style0 from "./SymptomInvestigationTable.vue?vue&type=style&index=0&id=68ed35d6&prod&lang=scss&scoped=true"
import style1 from "./SymptomInvestigationTable.vue?vue&type=style&index=1&id=68ed35d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed35d6",
  null
  
)

export default component.exports